<app-badge *ngIf="enable$ | async"
           customToolTip
           [contentTemplate]="tooltip">
  <span>{{ 'reports.nb_filters' | translate: { nbFilters: nbFilters$ | async } }}</span>
  <mat-icon class="material-icons-outlined info-icon">info</mat-icon>
</app-badge>
<ng-template #tooltip>
  <div class="display-flex flex-column row-gap-0-5rem">
    <app-source [item]="filter.dimension.payload"
                *ngFor="let filter of filters$ | async">
      {{ 'dashboard_report.includes' | translate }} '{{ filter.values }}'
    </app-source>
  </div>
</ng-template>
